/*
 * <personalization-fields> — Etsy-style custom option fields on the product page.
 *
 * Store KHONG phai Shopify Plus => khong dung Cart Transform de cong gia. Thay
 * vao do, khi Add to cart ta them variant "phi" tuong ung tu product an
 * `personalization-fee` (moi muc add-on = 1 variant, add qty = qty san pham).
 *
 * Nhiem vu:
 *  1. Dem ky tu textarea; hien "Personalization: +$X" tam tinh.
 *  2. Validate field required truoc khi cho Add to cart.
 *  3. Bo (disable) field optional trong => khong tao property rong.
 *  4. Sau khi mon chinh vao gio, them cac line phi tuong ung roi render lai gio.
 */
if (!customElements.get('personalization-fields')) {
  customElements.define(
    'personalization-fields',
    class PersonalizationFields extends HTMLElement {
      connectedCallback() {
        this.currency = this.dataset.currency || 'USD';
        this.addonInput = this.querySelector('.personalization__addon-input');
        this.addonLine = this.querySelector('.personalization__addon-line');
        this.addonDisplay = this.querySelector('.personalization__addon-display');
        this.errorBox = this.querySelector('.personalization__error');
        this.form = this.closest('form');

        // Map { gia_cents(string) -> variantId }
        try {
          this.feeMap = JSON.parse(this.dataset.feeMap || '{}');
        } catch (e) {
          this.feeMap = {};
        }

        this.onChange = this.recalculate.bind(this);
        this.addEventListener('input', this.onChange);
        this.addEventListener('change', this.onChange);

        if (this.form) {
          // Capture chay TRUOC listener submit cua <product-form>: validate +
          // prune + ghi lai cac phi can them.
          this._submitHandler = this.onFormSubmit.bind(this);
          this.form.addEventListener('submit', this._submitHandler, true);
        }

        // Sau khi mon chinh vao gio thanh cong -> them line phi.
        this._pendingFees = null;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
            if (evt && evt.source === 'product-form' && this._pendingFees) {
              this.appendFees();
            }
          });
        }

        this.setupCounters();
        this.recalculate();
      }

      disconnectedCallback() {
        if (this.form && this._submitHandler) {
          this.form.removeEventListener('submit', this._submitHandler, true);
        }
        if (this._unsubscribe) this._unsubscribe();
      }

      setupCounters() {
        this.querySelectorAll('.personalization__text').forEach((el) => {
          const field = el.closest('.personalization__field');
          const counter = field && field.querySelector('.personalization__count');
          if (!counter) return;
          const update = () => {
            counter.textContent = String(el.value.length);
          };
          el.addEventListener('input', update);
          update();
        });
      }

      /** Add-on (cents) dang ap dung cho 1 field, tuy loai va gia tri hien tai. */
      fieldAddon(field) {
        const base = parseInt(field.dataset.addon, 10) || 0;
        const type = field.dataset.type;
        const input = field.querySelector('.personalization__input');
        if (!input) return 0;

        if (type === 'dropdown') {
          if (!input.value) return 0;
          const opt = input.options[input.selectedIndex];
          const optPrice = opt ? parseInt(opt.dataset.price, 10) || 0 : 0;
          return optPrice > 0 ? optPrice : base;
        }
        if (type === 'file') {
          return input.files && input.files.length > 0 ? base : 0;
        }
        return input.value.trim() ? base : 0;
      }

      recalculate() {
        let total = 0;
        this.querySelectorAll('.personalization__field').forEach((field) => {
          total += this.fieldAddon(field);
        });

        if (this.addonInput) this.addonInput.value = String(total);

        if (this.addonLine && this.addonDisplay) {
          if (total > 0) {
            this.addonDisplay.textContent = '+' + this.formatMoney(total);
            this.addonLine.hidden = false;
          } else {
            this.addonLine.hidden = true;
          }
        }
      }

      /** Tra ve { variantId: soLuong } cac phi can them cho 1 mon (per unit). */
      collectFees() {
        const fees = {};
        this.querySelectorAll('.personalization__field').forEach((field) => {
          const cents = this.fieldAddon(field);
          if (cents <= 0) return;
          const variantId = this.feeMap[String(cents)];
          if (!variantId) return; // khong co variant phi khop -> bo qua
          fees[variantId] = (fees[variantId] || 0) + 1;
        });
        return fees;
      }

      onFormSubmit(evt) {
        this.hideError();

        // 1) Validate required
        const invalid = this.findFirstInvalidRequired();
        if (invalid) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          this.showError('Please fill in all required personalization fields.');
          invalid.focus();
          this._pendingFees = null;
          return;
        }

        // 2) Chuan bi phi (nhan voi qty mon chinh)
        const qty = parseInt(this.form.querySelector('[name="quantity"]')?.value, 10) || 1;
        const perUnit = this.collectFees();
        const fees = Object.keys(perUnit).length
          ? Object.fromEntries(Object.entries(perUnit).map(([id, n]) => [id, n * qty]))
          : null;
        this._pendingFees = fees;

        // 3) Bo field optional trong (sau khi da tinh phi)
        this.pruneEmptyOptional();
      }

      findFirstInvalidRequired() {
        let first = null;
        this.querySelectorAll('.personalization__input').forEach((input) => {
          if (first || !input.required) return;
          let empty;
          if (input.type === 'file') empty = !(input.files && input.files.length > 0);
          else empty = !String(input.value).trim();
          if (empty) first = input;
        });
        return first;
      }

      pruneEmptyOptional() {
        const disabled = [];
        this.querySelectorAll('.personalization__input').forEach((input) => {
          if (input.required) return;
          let empty;
          if (input.type === 'file') empty = !(input.files && input.files.length > 0);
          else empty = !String(input.value).trim();
          if (empty) {
            input.disabled = true;
            disabled.push(input);
          }
        });
        if (disabled.length) {
          setTimeout(() => disabled.forEach((el) => (el.disabled = false)), 0);
        }
      }

      /** Them cac line phi vao gio roi render lai cart drawer/notification. */
      appendFees() {
        const fees = this._pendingFees;
        this._pendingFees = null;
        if (!fees || !Object.keys(fees).length) return;

        const items = Object.entries(fees).map(([id, quantity]) => ({
          id: Number(id),
          quantity,
          properties: { _personalization_fee: 'true' },
        }));

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((response) => {
            if (cart && typeof cart.renderContents === 'function' && response.sections) {
              cart.renderContents(response);
            }
          })
          .catch((e) => console.error('personalization fee add failed', e));
      }

      showError(msg) {
        if (!this.errorBox) return;
        this.errorBox.textContent = msg;
        this.errorBox.hidden = false;
      }

      hideError() {
        if (this.errorBox) this.errorBox.hidden = true;
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }
    }
  );
}
